import { useRecordContext } from "react-admin"

export const Title = () => {
    const record = useRecordContext()
  
    return record && <p>Notification #{record.notificationId}</p>
  }